import * as React from 'react';

import Grid from '@mui/material/Grid';

import compass from '@app/imageAssets/homePage/compass.jpg';
import people2 from '@app/imageAssets/homePage/people-2.jpg';

import { FeatureList } from '.';

class SkillzPoweredGame extends React.PureComponent {
  public renderSkillzPoweredGameList(): JSX.Element {
    return (
      <ul className="home-page__feature-list-list">
        <li className="home-page__feature-list-list-item">
          <div className="diamond" />
          <p>Real-world prizes</p>
        </li>
        <li className="home-page__feature-list-list-item">
          <div className="diamond" />
          <p>Tournaments (head to head, brackets, live events)</p>
        </li>
        <li className="home-page__feature-list-list-item">
          <div className="diamond" />
          <p>Social features - leagues, trophies &amp; more</p>
        </li>
        <li className="home-page__feature-list-list-item">
          <div className="diamond" />
          <p>Guaranteed fair competition</p>
        </li>
        <li className="home-page__feature-list-list-item">
          <div className="diamond" />
          <p>24/7 player support &amp; fraud prevention</p>
        </li>
      </ul>
    );
  }

  public renderLetUsHelpList(): JSX.Element {
    return (
      <ul className="home-page__feature-list-list">
        <li className="home-page__feature-list-list-item">
          <div className="diamond" />
          <p>Built-in game analytics &amp; insights</p>
        </li>
        <li className="home-page__feature-list-list-item">
          <div className="diamond" />
          <p>Guidance for user acquisition &amp; retention</p>
        </li>
        <li className="home-page__feature-list-list-item">
          <div className="diamond" />
          <p>World class support for you &amp; your players</p>
        </li>
        <li className="home-page__feature-list-list-item">
          <div className="diamond" />
          <p>
            Skillz handles the back-end so you don’t have to (legal, live ops, payments, servers
            &amp; more)
          </p>
        </li>
      </ul>
    );
  }

  public render(): JSX.Element {
    return (
      <Grid
        container={true}
        spacing={3}
        justifyContent={'center'}
        className={'home-page__skillz-games-and-help-container background-white'}
      >
        <FeatureList
          title="Skillz-powered game features"
          image={people2}
          list={this.renderSkillzPoweredGameList()}
          altDescription="Skillz Players play Skillz Games with their friends together"
        />
        <FeatureList
          title="Let us help you succeed"
          image={compass}
          list={this.renderLetUsHelpList()}
          reverse={true}
          altDescription="The compass that directs to a success path "
        />
      </Grid>
    );
  }
}

export { SkillzPoweredGame };
